import React, { useRef } from 'react';
import { useGetPhonicsSoundsQuery } from '@/api/types';
import { SymbolType, CdnObjectType } from '@/types';
import { AudioPlayer, CdnMedia, RoundPlayButton } from '@/components';
import { useAssetCdn } from '@/context/Ui';
import { findSoundsInString } from '@/utils/sounds';

interface ManageAdminSymbolsWordOralBlendingProps {
  word: string;
}

export const ManageAdminSymbolsWordOralBlending = ({
  word,
}: ManageAdminSymbolsWordOralBlendingProps) => {
  const playerRef = useRef<AudioPlayer>(null);

  const { data: soundsData } = useGetPhonicsSoundsQuery();

  const wordSounds = findSoundsInString(
    soundsData?.getPhonicsSounds?.map((sound) => sound.name) || [],
    word,
  );

  const mediaUrls = useAssetCdn(
    wordSounds,
    SymbolType.Sound,
    CdnObjectType.Audio,
  );

  const mediaUrl = useAssetCdn(word, SymbolType.Word, CdnObjectType.Audio);

  return (
    <>
      <h6 className="font-bold">Word: {word}</h6>

      <CdnMedia
        className="w-full h-auto"
        symbol={word}
        symbolType={SymbolType.Word}
        objectType={CdnObjectType.Image}
        width={280}
        height={280}
      />

      <RoundPlayButton
        className="my-6"
        size="sm"
        onClick={() => {
          playerRef.current?.play();
        }}
      />

      <AudioPlayer
        ref={playerRef}
        src={[
          ...(Array.isArray(mediaUrls)
            ? mediaUrls
            : !!mediaUrls
              ? [mediaUrls]
              : []),
          ...(Array.isArray(mediaUrl)
            ? mediaUrl
            : !!mediaUrl
              ? [mediaUrl]
              : []),
        ]}
        pause={500}
      />
    </>
  );
};
